import {
  Box,
  Button,
  Flex,
  Grid,
  Img,
  Square,
  Text,
  Wrap,
} from "@chakra-ui/react";
import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import Badge_Component from "../Badge/Badge_Component";
import * as api from "../../../services/api";
import { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import salary from "../../../Assets/salary_icon2.svg";
import map from "../../../Assets/location.svg";
import monitor from "../../../Assets/monitor.svg";
import people from "../../../Assets/people.svg";
import roboto from "@fontsource/roboto";
import epilogue from "@fontsource/epilogue";
import folder from "../../../Assets/folder.svg";
import dot from "../../../Assets/dot.svg";
import shareicon from "Assets/share.png";
import Swal from "sweetalert2";

const Jobrole_component = ({ data }) => {
  // console.log(data);
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();
  // const handleDetail = () => {
  //   navigate("/details");
  // };
  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];

  const [company, setCompany] = useState(data?.companyID);
  const [numApplication, setNumApplication] = useState();

  const getAllApplicationsForJob = async () => {
    setLoading(true);
    try {
      const applications = await api.getAllApplicationsForJob(data._id);
      setNumApplication(applications.data.data.total);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  useEffect(() => {
    const apiCall = async () => {
      const result = await Promise.all([getAllApplicationsForJob()]);
    };
    apiCall();
  }, []);
  const sliceText = (text) => {
    if (text.length >= 30) {
      const sliced = text.slice(0, 31);
      return `${sliced}...`;
    }
    return text;
  };

  const [hoverState, sethoverState] = useState(false);

  const handleHover = () => {
    sethoverState(true);
  };

  const handleLeave = () => {
    sethoverState(false);
  };

  const shareLink = () => {
    navigator.clipboard.writeText(
      `${window.location.host}/hiring/job-details/${data?._id}/${company?._id}`
    );
    Swal.fire({
      icon: "success",
      title: "Link copied successfully",
    });
  };

  return (
    <div>
      <Box
        // h={["auto", "auto", 339, 339]}

        w={["95%", "95%", 415, 415]}
        css={{
          "@media screen and (min-width: 1550px) and (max-width:1980px)": {
            height: 345,
          },
          "@media screen and (min-width: 1280px) and (max-width:1540px)": {
            height: 345,
          },
        }}
        border="1px solid #D9D9D9"
        borderRadius={12}
        mx={3}
        my={3}
        p={1}
        _hover={{ boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.13)" }}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        <Box mx={3} my={3}>
          <Flex alignItems={"center"}>
            <Flex
              color={hoverState ? "#00D4AE" : "#000"}
              fontWeight={500}
              fontSize={15}
              h={29}
              w={172}
              bg={numApplication ? "rgba(0, 212, 174, 0.18)" : "#F4F4F4"}
              borderRadius={15}
              my={2}
              py={1}
              alignItems="center"
              justify={"center"}
              gap={2}
              className="applications"
              border={"1px solid #E7E6E8"}
              fontFamily={"Roboto"}
            >
              <Img src={folder} alt="icon" />
              {numApplication && !loading ? (
                <Text color={hoverState ? "#00D4AE" : "#000"}>
                  {numApplication} applications
                </Text>
              ) : (
                <Text color={"#000"}>No application</Text>
              )}
            </Flex>
            <Img
              _hover={{
                cursor: "pointer",
                borderRadius: "50%",
                transform: "scale(1.1)",
              }}
              src={shareicon}
              onClick={() => shareLink()}
              style={{
                marginLeft: "auto",
                cursor: "pointer",
                height: "25px",
                width: "25px",
              }}
            />
          </Flex>
          <Box mt={19}>
            {/* Job Role Component plus Company Name */}
            <Flex justifyContent="left" align={"center"}>
              {/* Logo */}
              <Square
                size={42}
                borderRadius={8}
                border={"1px solid #ececec"}
                overflow={"hidden"}
              >
                <img
                  height={"100%"}
                  width={"100%"}
                  src={company.profilePhoto}
                  alt="logo"
                />
              </Square>
              {/* Name and company */}
              <Box ml={4} w={364}>
                <Text
                  w="auto"
                  fontSize={20}
                  fontWeight={550}
                  textAlign="left"
                  fontFamily={"Roboto"}
                  color={"#0B0019"}
                >
                  {/* {role} */}
                  {data.jobRoleTitle ? sliceText(data.jobRoleTitle) : ""}
                </Text>
                <Flex>
                  <Text
                    fontSize={14}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color={"#9D99A3"}
                    textAlign="left"
                  >
                    {company?.companyName}
                  </Text>
                  {/* <Text
                    fontSize={15}
                    fontFamily={"Roboto"}
                    fontWeight={500}
                    color="#767676"
                  >
                    {moment(data.createdAt).format("DD-MM-YYYY")}
                  </Text> */}
                </Flex>
              </Box>
            </Flex>
            {/* ********New ******* */}
            <Flex flexDir={"column"} my={4} gap={1.5}>
              <Flex gap={[2, 2, 2, 2, 6, 6, 6]}>
                {/* salary */}
                <Flex align="center" gap={1}>
                  <img src={salary} alt="salary" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Salary -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.packageOffered} LPA
                  </Text>
                </Flex>
                <Img src={dot} />
                {/* location */}
                <Flex align="center" gap={1}>
                  <img src={map} alt="location" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Location -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.location.slice(0, 10)}
                  </Text>
                </Flex>
              </Flex>

              <Flex gap={[2, 2, 2, 2, 6, 6, 6]}>
                {/* Platform */}
                <Flex align="center" gap={1}>
                  <img src={monitor} alt="platform" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Platform -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                    textTransform={"capitalize"}
                  >
                    {data.platform}
                  </Text>
                </Flex>
                <Img src={dot} />
                {/* openings */}
                <Flex align="center" gap={1}>
                  <img src={people} alt="platform" />
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                    color="#767676"
                  >
                    Openings -
                  </Text>
                  <Text
                    fontSize={[15, 15, 16, 16]}
                    fontWeight={550}
                    fontFamily={"Roboto"}
                    color="#767676"
                  >
                    {data.openings}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Box my={2}>
              <Badge_Component num={levels[data.requiredLevel]} />
            </Box>
            {/* Posted On */}
            <Flex mt={2} gap={2} justify="space-between">
              <Text
                fontSize={[12, 12, 14, 14]}
                fontWeight={500}
                fontFamily={"Roboto"}
                color="#767676"
              >
                Posted on : {moment(data.createdAt).format("DD-MM-YYYY")}
              </Text>
              <Text
                fontSize={[12, 12, 14, 14]}
                fontWeight={500}
                fontFamily={"Roboto"}
                color="#767676"
              >
                Expires on : {moment(data.applyByDate).format("DD-MM-YYYY")}
              </Text>
            </Flex>
            {/* Button */}
            <Box my={4} mt={2}>
              <Link to={`/hiring/recruiter/details/${data._id}`}>
                <Button
                  borderRadius={12}
                  w="100%"
                  h={41}
                  alignItems="center"
                  fontSize={20}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  letterSpacing={"0.04em"}
                  mb={0}
                  border={hoverState ? "" : "1px solid #E7E6E8"}
                  color={hoverState ? "#FFFFFF" : ""}
                  bg={hoverState ? "#6C56FB" : ""}
                  _hover={{
                    boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                  }}
                >
                  View details
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Jobrole_component;
